import type { ReactNode } from "react";

type SectionTitleProps = {
  upper: string;
  children: ReactNode;
  under?: ReactNode;
  light?: boolean;
  className?: string;
};

export default function SectionTitle({ upper, children, under, light = false, className = "" }: SectionTitleProps) {
  return (
    <div className={`text-center ${className}`}>
      <p className={`inline-flex items-center gap-2 text-sm font-bold tracking-[0.2em] ${light ? "text-white/90" : "text-primary-600"}`}>
        <span className={`h-px w-6 ${light ? "bg-white/60" : "bg-primary-400"}`} />
        {upper}
        <span className={`h-px w-6 ${light ? "bg-white/60" : "bg-primary-400"}`} />
      </p>
      <h2 className={`mt-3 text-balance font-heading text-2xl font-black leading-snug md:text-4xl ${light ? "text-white" : "text-foreground-950"}`}>
        {children}
      </h2>
      {under ? (
        <div className={`mt-4 text-pretty text-base leading-relaxed md:text-lg ${light ? "text-white/90" : "text-foreground-600"}`}>
          {under}
        </div>
      ) : null}
    </div>
  );
}